(function () {
  'use strict';

  var ROOT = document.getElementById('ll-wp-root');
  if (!ROOT) return;

  var delay      = parseInt(ROOT.dataset.delay, 10) || 8;
  var exitIntent = ROOT.dataset.exit === 'true';
  var backdrop   = document.getElementById('ll-wp-backdrop');
  var popup      = document.getElementById('ll-wp-popup');
  var circle     = document.getElementById('ll-wp-circle');
  var closeBtn   = document.getElementById('ll-wp-close');
  var laterBtn   = document.getElementById('ll-wp-later');
  var emailInput = document.getElementById('ll-wp-email');
  var errorEl    = document.getElementById('ll-wp-error');
  var formWrap   = popup.querySelector('.ll-wp-form-wrap');
  var successEl  = document.getElementById('ll-wp-success');
  var keepBtn    = document.getElementById('ll-wp-keep');
  var copyBtn    = document.getElementById('ll-wp-copy');
  var codeText   = document.getElementById('ll-wp-code');

  // ── localStorage helpers ──
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function seen()   { return lsGet('ll_welcome_seen') === '1'; }
  function signed() { return lsGet('ll_welcome_signed') === '1'; }

  // ── Focus trap ──
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var els = Array.prototype.filter.call(popup.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function handleEsc(e) { if (e.key === 'Escape') closePopup(); }

  // ── Open / close ──
  var openerEl = null;
  var isOpen = false;

  function openPopup(opener, force) {
    if (isOpen) return;
    if (signed() && !force) return;
    isOpen = true;
    // Opening by any route counts as seen, so the auto-popup won't fire again
    lsSet('ll_welcome_seen', '1');
    triggered = true;
    openerEl = opener || null;
    hideCircle();
    backdrop.classList.add('ll-wp-visible');
    popup.classList.add('ll-wp-visible');
    document.body.style.overflow = 'hidden';
    popup.addEventListener('keydown', trapFocus);
    document.addEventListener('keydown', handleEsc);
    requestAnimationFrame(function () {
      if (successEl.classList.contains('ll-wp-show')) {
        if (copyBtn) copyBtn.focus();
      } else if (emailInput) {
        emailInput.focus();
      }
    });
  }

  function closePopup() {
    if (!isOpen) return;
    isOpen = false;
    backdrop.classList.remove('ll-wp-visible');
    popup.classList.remove('ll-wp-visible');
    document.body.style.overflow = '';
    popup.removeEventListener('keydown', trapFocus);
    document.removeEventListener('keydown', handleEsc);
    if (openerEl && document.contains(openerEl) && openerEl !== circle) { openerEl.focus(); }
    openerEl = null;
    if (!signed()) {
      showCircle();
      if (circle) circle.focus({ preventScroll: true });
    }
  }

  // ── Circle ──
  function showCircle() { if (circle && !signed()) circle.classList.add('ll-wp-visible'); }
  function hideCircle() { if (circle) circle.classList.remove('ll-wp-visible'); }

  // ── States ──
  function showSuccess() {
    lsSet('ll_welcome_signed', '1');
    lsSet('ll_welcome_seen', '1');
    if (formWrap) formWrap.classList.add('ll-wp-hide');
    successEl.classList.add('ll-wp-show');
    openPopup(null, true);
    // Tidy the URL so a refresh doesn't reopen it
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        url.hash = '';
        history.replaceState(null, '', url.pathname + (url.search || ''));
      }
    } catch (e) {}
  }

  function showError() {
    lsSet('ll_welcome_seen', '1');
    if (errorEl) errorEl.classList.add('ll-wp-show');
    openPopup(null, true);
  }

  // ── Wait for the festive confetti (#ll-fc canvas) to finish ──
  function whenConfettiGone(cb) {
    var start = Date.now();
    (function check() {
      if (!document.getElementById('ll-fc') || Date.now() - start > 15000) {
        setTimeout(cb, 500);
      } else {
        setTimeout(check, 250);
      }
    })();
  }

  // ── First-visit trigger ──
  var triggered = false;
  function triggerPopup() {
    if (triggered || seen() || signed()) return;
    triggered = true;
    whenConfettiGone(function () {
      if (seen() || signed() || isOpen) return;
      lsSet('ll_welcome_seen', '1');
      openPopup(null);
    });
  }

  function setupExitIntent() {
    document.addEventListener('mouseout', function handler(e) {
      if (!e.relatedTarget && e.clientY <= 0) {
        document.removeEventListener('mouseout', handler);
        triggerPopup();
      }
    });
  }

  // ── Init ──
  function init() {
    var params = new URLSearchParams(window.location.search);
    var postedOk  = !!document.getElementById('ll-wp-posted') || params.get('customer_posted') === 'true';
    var postedErr = !!document.getElementById('ll-wp-posted-error');

    if (postedOk)  { showSuccess(); return; }
    if (postedErr) { showError(); return; }
    if (signed()) return;
    // Circle shows from the very first second as a little hook
    showCircle();
    if (seen()) return;

    setTimeout(triggerPopup, delay * 1000);
    if (exitIntent && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      setupExitIntent();
    }
  }

  // ── Event bindings ──
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (laterBtn) laterBtn.addEventListener('click', closePopup);
  if (backdrop) backdrop.addEventListener('click', closePopup);
  if (keepBtn)  keepBtn.addEventListener('click', closePopup);
  if (circle) circle.addEventListener('click', function () { openPopup(circle); });

  // Simple client-side check before posting
  var formEl = document.getElementById('ll-welcome-form');
  if (formEl && emailInput) {
    formEl.addEventListener('submit', function (e) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) {
        e.preventDefault();
        if (errorEl) errorEl.classList.add('ll-wp-show');
        emailInput.focus();
      } else {
        lsSet('ll_welcome_seen', '1');
      }
    });
  }

  // ── Copy button ──
  function selectCode() {
    var range = document.createRange();
    range.selectNodeContents(codeText);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }
  if (copyBtn && codeText) {
    copyBtn.addEventListener('click', function () {
      var code = codeText.textContent.trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = 'Copied';
          setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
        }, selectCode);
      } else {
        selectCode();
      }
    });
  }

  init();
})();
